<div class="spinner-wrapper {{ inverse ? 'inverse' : '' }} col">
  <img
    *ngIf="inverse === false"
    src="images/spinner_black.gif"
    alt="ids Spinner"
  />
  <img
    *ngIf="inverse === true"
    src="images/spinner_white.gif"
    alt="ids Spinner"
  />
  <div *ngIf="longloadingText !== ''" class="loadingtext">
    {{ longloadingText }}
  </div>
</div>
